import request from '@/utils/request'

// 运营端正式门禁开门记录（主后端 machine_record）
export function listAdminAccessControlInout(params) {
  return request({
    url: '/iot.listAdminAccessControlInout',
    method: 'get',
    params
  }).then(response => {
    const res = response.data
    if (res.code === 0) {
      return res
    }
    throw new Error(res.msg || 'Failed to get admin access records')
  })
}

// 运营人员权限范围内的正式 ISUP 门禁设备
export function listAdminAccessControl(params) {
  return request({
    url: '/iot.listAdminAccessControl',
    method: 'get',
    params
  }).then(response => {
    const res = response.data
    if (res.code === 0) {
      return res
    }
    throw new Error(res.msg || 'Failed to get admin access controls')
  })
}

export function listAdminCommunitys(params) {
  return request({
    url: '/community.listAdminCommunitys',
    method: 'get',
    params
  }).then(response => {
    const res = response.data
    if (res.code === 0) {
      return res
    }
    throw new Error(res.msg || 'Failed to get admin communities')
  })
}
